import { render, staticRenderFns } from "./addfictitiousgoods.vue?vue&type=template&id=3bd8b126&scoped=true&"
import script from "./addfictitiousgoods.vue?vue&type=script&lang=js&"
export * from "./addfictitiousgoods.vue?vue&type=script&lang=js&"
import style0 from "./addfictitiousgoods.vue?vue&type=style&index=0&id=3bd8b126&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8b126",
  null
  
)

export default component.exports